import React from "react";
import { Check } from "lucide-react";
import { BottomSheet } from "./StorySheets";
import { VideoTrimTrack, fmtClock } from "./VideoTrimTrack";

// Lot 613 — feuille « Extrait » : poignées début / fin (1 s → maxSec) + qualité du clip quand il sera ré-encodé.
export const StoryTrimSheet = ({ open, onClose, videoDur, maxSec, trimStart, trimLen, setTrim, clipQuality, setClipQuality, willProcess, thumbsSrc = null, t }) => {
  const end = Math.min(videoDur || 0, trimStart + trimLen);
  return (
    <BottomSheet open={open} onClose={onClose} title={t("story.tool_extract", "Extrait")} testId="story-fs-trim-sheet" maxH="60dvh">
      <p className="text-xs text-white/70">{t("story.trim_hint2", "Fais glisser les poignées pour choisir le début et la fin (max {n} s).").replace("{n}", String(maxSec))}</p>
      <div className="text-sm font-bold mt-1" style={{ color: "var(--yalola-primary)" }} data-testid="story-fs-trim-times">
        {fmtClock(trimStart)} → {fmtClock(end)}
        <span className="font-normal text-xs ml-1 text-white/70">({Math.round(end - trimStart)} s)</span>
      </div>
      <div className="mt-2">
        <VideoTrimTrack videoDur={videoDur} maxSec={maxSec} start={trimStart} len={trimLen} onChange={setTrim} dark thumbsSrc={open ? thumbsSrc : null} testId="story-fs-trim" />
      </div>
      {willProcess && (
        <div className="mt-3">
          <div className="text-[11px] font-semibold mb-1 text-white/70">{t("story.clip_quality", "Qualité du clip")}</div>
          <div className="grid grid-cols-3 gap-1.5" data-testid="story-fs-clip-quality">
            {[["light", t("story.q_light", "Léger")], ["standard", t("story.q_standard", "Standard")], ["hd", t("story.q_hd", "Haute")]].map(([k, lab]) => (
              <button key={k} type="button" onClick={() => setClipQuality(k)} className="text-xs rounded-full py-1.5 font-semibold border transition-colors" style={{ borderColor: clipQuality === k ? "var(--yalola-primary)" : "rgba(255,255,255,.2)", background: clipQuality === k ? "var(--yalola-primary)" : "transparent", color: "#fff" }} data-testid={`story-fs-clip-q-${k}`}>{lab}</button>
            ))}
          </div>
        </div>
      )}
      <button type="button" onClick={onClose} className="mt-4 w-full h-11 rounded-full text-sm font-bold text-white flex items-center justify-center gap-1.5" style={{ background: "var(--yalola-primary)" }} data-testid="story-fs-trim-done"><Check size={16} /> {t("story.done", "Terminé")}</button>
    </BottomSheet>
  );
};
